import React, {useEffect, useState, useCallback} from "react";

import {useSelector, useDispatch} from "react-redux";

import {
  Linking,
  Platform,
  StyleSheet,
  Text,
  TextInput,
  TouchableOpacity,
  View,
} from "react-native";
import {Button} from "../../../components/core/Button";
import {globalFontStyle} from "../../../assets";
import Colors from "../../../assets/Color/Colors";

import {globalConst} from "../../../utils/globalConstant";
import {isMobile} from "../../../utils/commonMethods";
import {CountryRegEx, RegEx} from "../../../utils/commonMethods";
import ShowError from "../../../common/ShowError";
import GoogleLoginRT from "../../../common/googleLogin";
import {globalImport} from "../../../common/globalImports";
import AppleButtonCustom from "./AppleButtonCustom";
import EmailLogin from "./EmailLogin";
import FastImage from "../../../common/FastImage";
import {email_black, phone_black, logoName} from "../../../utils/images";
import LoginViaMobile from "./LoginViaMobile";
import { magic } from "../../../lib/magic";
import { setLoggingIn } from "../redux/login.action";
import CountrySelection from "./CountrySelection";
import { getConfig } from "../../../utils/commonredux/commonRedux.action";
import { clearMagicLinkState } from "../../../utils/magicLinkUtils";
const showingData = ["mobile", "gmail", "apple", "email"];

function MobileLogin({
  onLoginSubmit,
  onPromoSuccessSet,
  setCountry,
  country,
  isWhatsappUpdate,
  setWhatsappUpdate,
  mobileSigninReact,
  isIndia,
  showMobileOnly,
  isProfile,
  emailLogin,
  setEmailLogin,
  setMethodType,
  methodType = false,
}) {
  const [error, setError] = useState("");
  const [showCountrySelection, setShowCountrySelection] = useState(false);
  const dispatch = useDispatch();

  const [mobileLogin, setMobileLogin] = useState(false);

  const [loginConfig, setLoginConfig] = useState({});

  const [selectedCountryRegEx, setSelectedCountryRegEx] = useState(
    CountryRegEx.IN,
  );

  const globalConfigData = useSelector(
    state => state.utilReducer.globalConfigData,
  );
  console.log("GLOBAL CONFIG DATA", globalConfigData);
  let otpReSuccess = useSelector(({login}) => login.interimRegisterSuccess);

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (otpReSuccess?.verified === false) {
      setError(otpReSuccess?.msg);
    }
  }, [otpReSuccess]);

  const termsAndCondition = globalConfigData?.termsAndCondition;
  const privacyPolicy = globalConfigData?.privacyPolicy;
  const amlPolicy = globalConfigData?.antiMoneyLaundering;

  const onLinkClick = (e, link) => {
    e.preventDefault();
    if (link) {
      Linking.openURL(link);
    }
  };

  const onMobileSelect = () => {
    setMethodType(true);
  };

  useEffect(() => {
    // setLoginConfig({
    //   enableWhatsapp: globalConfigData?.loginOptions?.whatsapp_enabled,
    //   enableSms: globalConfigData?.loginOptions?.sms_enabled,
    //   enableGmail: globalConfigData?.loginOptions?.gmail_enabled,
    //   enableAppleLogin: globalConfigData?.loginOptions?.apple_enabled,
    //   enableEmail: globalConfigData?.loginOptions?.email_enabled,
    // });
    setSelectedCountryRegEx(CountryRegEx[country.code]);
  }, [country, globalConfigData?.countries]);

  // const responseGoogle = async (response) => {
  //   signIn(response);
  // };

  const responseGoogleError = errorResponse => {
    setError(errorResponse?.error);
  };

  useEffect(() => {
    setEmailLogin(false);
  }, []);

  useEffect(() => {
    if (otpReSuccess?.verified === false) {
      setError(otpReSuccess?.msg);
    }
  }, [otpReSuccess]);

  useEffect(() => {
    let timeout;
    if (error) {
      timeout = setTimeout(() => {
        setError("");
      }, 5000);
    }

    return () => {
      timeout && clearTimeout(timeout);
    };
  }, [error]);

  useEffect(() => {
    // Show country selection if detected_location is false
    if (globalConfigData?.detected_location === false) {
      setShowCountrySelection(true);
    }
  }, [globalConfigData?.detected_location]);

  const handleCountrySelect = async (selectedCountry) => {
    // Update the country in parent component but maintain India's phone code
    setCountry?.({
      ...selectedCountry,
      dial_code: "+91", // Keep Indian phone code
      code: selectedCountry.code, // Keep selected country's code for login method determination
      name: selectedCountry.name // Keep selected country's name
    });
    localStorage.setItem('selectedCountry', selectedCountry.code);
    // Hide country selection screen

    dispatch(getConfig({
      headers: {
        country: selectedCountry.code
      }
    }));
    setShowCountrySelection(false);
    
    // Fetch new config after country selection
  };

  const onFormSubmit = (source, event) => {
    onLoginSubmit(watchNo, false, source);
  };

  const EmailComp = () => {
    return (
      <Button
        variant="outline"
        onPress={() => setEmailLogin(true)}
        style={[
          {
            marginBottom: 16,
            width: '100%',
            height: 48
          }
        ]}
        leftIcon={() => (
          <FastImage source={email_black()} style={{height: 22, width: 22}} />
        )}
      >
        Sign In with Email
      </Button>
    );
  };

  const MagicLinkComp = () => {
    const isLoggingIn = useSelector(state => state.login.isLoggingIn);
    const magicLinkAuthLoading = useSelector(state => state.login.magicLinkAuthLoading);
    const dispatch = useDispatch();
    
    // Use magic link auth loading state for better UX
    const isLoading = magicLinkAuthLoading || isLoggingIn;
    
    return (
      <View style={{width: '100%', marginBottom: 16}}>
        <Button
          onPress={async () => {
            try {
              if(globalImport.isWeb) {
                dispatch(setLoggingIn(true));
                localStorage.setItem('isOauthRedirect', true);
                
                const res = await magic.oauth2.loginWithRedirect({
                  provider: 'google',
                  redirectURI: `${window.location.origin}/Login`,
                });
              }
            } catch(e) {
              // Clear magic link state on error
              clearMagicLinkState();
            }
          }}
          variant="primary"
          size="medium"
          loading={isLoading}
          loadingText="Signing in..."
          disabled={isLoading}
          style={{
            width: '100%',
            height: 48
          }}
        >
          {isLoading ? "Logging in" : "Continue with Google"}
        </Button>
      </View>
    );
  };

  const GmailComp = () => {
    return (
      <View style={{
        width: '100%',
        marginBottom: 16
      }}>
        <GoogleLoginRT
          googleClientId={globalConst?.googleClientId}
          responseGoogle={mobileSigninReact}
          isDesktop={!isMobile()}
          responseGoogleError={responseGoogleError}
          buttonStyle={{
            width: '100%',
            height: 48
          }}
        />
      </View>
    );
  };

  const MobileComp = () => {
    return (
      <Button
        variant="outline"
        onPress={() => onMobileSelect(true)}
        style={[
          {marginVertical: 20},
          !globalImport.isWeb ? {flex: 0} : !isMobile() ? {flex: 1} : {},
        ]}
        leftIcon={() => (
          <FastImage source={phone_black()} style={{height: 22, width: 22}} />
        )}
      >
        <Text>
          Continue via Phone No
        </Text>
      </Button>
    );
  };

  return (
    <>
      {showCountrySelection ? (
        <CountrySelection onCountrySelect={handleCountrySelect} />
      ) : emailLogin ? (
        <EmailLogin
          onLoginSubmit={onLoginSubmit}
          onPromoSuccessSet={onPromoSuccessSet}
          isIndia={isIndia}
          showMobileOnly={showMobileOnly}
        />
      ) : (
        <View
          style={{
            flex: 1,
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: Colors.bgWhite,
            minHeight: '100vh'
          }}>
          <View style={{
            width: isMobile() ? '100%' : 400,
            alignItems: "center",
            paddingHorizontal: 16
          }}>
            <FastImage
              source={require('../../../assets/images/appicon.svg')}
              style={{
                width: 64,
                height: 64,
                marginBottom: 24
              }}
              resizeMode="contain"
            />
            
            <Text style={{
              ...globalFontStyle.appFontHeading,
              fontSize: 24,
              marginBottom: 32,
              color: Colors.black,
              textAlign: 'center'
            }}>
              Welcome to TradeX Markets
            </Text>

            <View style={{width: '100%'}}>
              {globalConfigData?.loginOptions?.loginOrder?.map((item, index) => {
                switch (item) {
                  case "magic_link_enabled":
                    return !showMobileOnly && <MagicLinkComp key={`login-option-${index}`} />;
                  case "gmail_enabled":
                    return !showMobileOnly && <GmailComp key={`login-option-${index}`} />;
                  case "email_enabled":
                    return !showMobileOnly && <EmailComp key={`login-option-${index}`} />;
                  case "apple_enabled":
                    return (
                      !showMobileOnly &&
                      Platform.OS === "ios" && (
                        <AppleButtonCustom
                          key={`login-option-${index}`}
                          callBackAppleLogin={res => mobileSigninReact(res)}
                        />
                      )
                    );
                  default:
                    return null;
                }
              })}
            </View>

            {isIndia && (
              <>
                <View style={[styles.dashedLineStyle, {width: '100%'}]}>
                  <Text style={styles.dashedLineText}>OR</Text>
                </View>

                <View style={{width: '100%'}}>
                  <LoginViaMobile
                    country={country}
                    setCountry={setCountry}
                    isIndia={isIndia}
                    showMobileOnly={showMobileOnly}
                    onPromoSuccessSet={onPromoSuccessSet}
                    onLoginSubmit={onLoginSubmit}
                  />
                </View>
              </>
            )}

            {!showMobileOnly && (
              <View
                style={{
                  flexDirection: "row",
                  alignItems: "center",
                  marginTop: 20,
                  width: '100%',
                }}>
                <Text
                  style={{
                    ...globalFontStyle.appFontSmallText,
                    color: Colors.grey,
                    flex: 1,
                    textAlign: "center",
                  }}>
                  By contnuing, you agree to our
                  <Text
                    style={{
                      ...globalFontStyle.appFontSmallText,
                      color: "#0d6efd",
                    }}
                      onPress={e =>
                        onLinkClick(
                          e,
                          privacyPolicy ||
                            "https://tradexapp.zendesk.com/hc/en-us/articles/7198021845149-Privacy-Policy",
                        )
                      }>
                    {" "}
                    Privacy Policy,{" "}
                  </Text>
                  <Text
                    className="app-font-small-text"
                    style={{
                      ...globalFontStyle.appFontSmallText,
                      color: "#0d6efd",
                    }}
                      onPress={e =>
                        onLinkClick(
                          e,
                          termsAndCondition ||
                            "https://tradexapp.zendesk.com/hc/en-us/articles/7197989869213-Terms-Conditions",
                        )
                      }>
                    Terms{" "}
                  </Text>
                  &{" "}
                  <Text
                    className="app-font-small-text"
                    style={{
                      ...globalFontStyle.appFontSmallText,
                      color: "#0d6efd",
                    }}
                      onPress={e =>
                        onLinkClick(
                          e,
                          amlPolicy ||
                            "https://tradexapp.zendesk.com/hc/en-us/articles/11341149311261-Anti-Money-Laundering-Policy",
                        )
                      }>
                    AML Policy.
                  </Text>
                </Text>
              </View>
            )}

            {error !== null && error !== "" && (
              <Text style={styles.loginErrorBar}>{error}</Text>
            )}
          </View>
        </View>
      )}
    </>
  );
}

export default React.memo(MobileLogin);

const styles = StyleSheet.create({
  loginErrorBar: {
    ...globalFontStyle.appFontSubText,
    backgroundColor: "#ff2626",
    paddingVertical: 8,
    width: "100%",
    paddingLeft: 5,
    alignItems: "center",
    color: Colors.bgWhite,
  },
  inputDiv: {
    flexDirection: "row",
    marginBottom: 10,
    paddingLeft: 0,
    borderRadius: 8,
    alignItems: "center",
    borderColor: Colors.borderColor,
    borderWidth: 1,
  },
  buttonStyle: {
    paddingVertical: 12,
    alignItems: "center",
    borderRadius: 5,
    flexDirection: "row",
    borderColor: Platform.OS !== "ios" ? "#dadce0" : Colors.black,
    borderWidth: 1,
    justifyContent: "center",
  },
  dashedLineStyle: {
    borderStyle: "dashed",
    borderWidth: 1,
    borderColor: "#00000033",
    marginVertical: 25,
    alignItems: "center",
  },
  dashedLineText: {
    position: "absolute",
    top: -8,
    textAlign: "center",
    width: 40,
    backgroundColor: Colors.bgWhite,
  },
});
